import { ServiceAdapter } from './serviceAdapter';

export class NewVehiclesAdapter extends ServiceAdapter {
  static adaptItems(items) {
    return items.map(item => ({
      id: item.id,
      name: item.title,
      brand: this._getChannelBrand(),
      category: item.category,
      area: 'Novos',
      price: item.price,
    }));
  }

  static adaptItem(item) {
    if (!item) return null;

    return {
      id: item.id,
      name: item.title,
      brand: this._getChannelBrand(),
      category: item.category,
      area: 'Novos',
      price: item.price,
    };
  }

  static _getChannelBrand() {
    const channelBrandMetaTag = document.querySelector(
      "meta[name='fca_api_brand']",
    );

    if (!channelBrandMetaTag) return '';

    const channelBrand = String(channelBrandMetaTag.content);

    const capitalizedChannelBrand =
      channelBrand[0].toUpperCase() + channelBrand.slice(1);

    return capitalizedChannelBrand;
  }
}
